
class exports.Column

    constructor: ->
        @id = null
        @display_name = ''
        @class_name = ''

        @is_editable = true
        @validation_rules = []
        @completion_rules = []
        @input_type = ''
        @has_static_options = false
        @options_alias = null
        @column_alias = ''

        # a getOptions(product) function will be magically added for autocompletes
